import { render, staticRenderFns } from "./InformationNotes.vue?vue&type=template&id=861d0e90&"
import script from "./InformationNotes.vue?vue&type=script&lang=js&"
export * from "./InformationNotes.vue?vue&type=script&lang=js&"
import style0 from "./InformationNotes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports